import { render, staticRenderFns } from "./ServiceJoinStep1Contentsogmmr.vue?vue&type=template&id=4797c376"
import script from "./ServiceJoinStep1Contentsogmmr.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep1Contentsogmmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4797c376')) {
      api.createRecord('4797c376', component.options)
    } else {
      api.reload('4797c376', component.options)
    }
    module.hot.accept("./ServiceJoinStep1Contentsogmmr.vue?vue&type=template&id=4797c376", function () {
      api.rerender('4797c376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep1Contentsogmmr.vue"
export default component.exports